export default {
  dashboard: 'Dashboard',
  about: '关于',
  workbench: '工作台',
  analysis: '首页',
};
